import { create } from 'zustand';

interface ChatState {
  /** Draft messages keyed by message ID (or 'new' for new conversations) */
  drafts: Record<string, string>;
  /** A message to be auto-sent when ChatView mounts on a new conversation */
  pendingNewMessage: string | null;
  /** Set a draft message for a conversation */
  setDraft: (messageId: string, content: string) => void;
  /** Clear a draft message after sending */
  clearDraft: (messageId: string) => void;
  /** Set a pending message to be auto-sent in a new conversation */
  setPendingNewMessage: (content: string) => void;
  /** Clear the pending new message after it has been sent */
  clearPendingNewMessage: () => void;
}

export const useChatStore = create<ChatState>((set) => ({
  drafts: {},
  pendingNewMessage: null,
  setDraft: (messageId, content) =>
    set((state) => ({
      drafts: { ...state.drafts, [messageId]: content },
    })),
  clearDraft: (messageId) =>
    set((state) => {
      const { [messageId]: _, ...rest } = state.drafts;
      return { drafts: rest };
    }),
  setPendingNewMessage: (content) =>
    set({ pendingNewMessage: content }),
  clearPendingNewMessage: () =>
    set({ pendingNewMessage: null }),
}));
